export default "__VITE_PUBLIC_ASSET__bee7e6ae__"